import { LocalizedDate, LocalizedText } from '@mews/framework';
import { WallClockDate } from '@mews/framework/datetime';
import { getShortDayNameKey } from './utils/getShortDayNameKey';

export const LocalizedDateWithDay = ({ date }: { date: WallClockDate }) => (
    <span>
        <LocalizedText textKey={getShortDayNameKey(date)} /> <LocalizedDate date={date} />
    </span>
);
